import { createCostWithCurrency, ICost } from '../../../../../../../shared/localization/currency';
import { IExtraImageCost } from '../../listImages/queries/use-query-images';

export function transformExtraImageCost(extraImageCost: IExtraImageCost | null): ICost | null {
    if (extraImageCost && extraImageCost.currency) {
        return createCostWithCurrency(extraImageCost.value, extraImageCost.currency);
    }

    return null;
}
